/*@flow*/
import React from 'react';
import StructTemplate from './Struct';
import Struct from 'lib/proforma/templates/Struct';
import type { LocalsT } from 'lib/proforma/types';

export default (Struct.clone({
  Fieldset: (locals: LocalsT) => {
    const pathKey = locals.path[locals.path.length - 1];
    return (
      <StructTemplate
        pathKey={pathKey}
        iconClass={locals.iconClass}
        label={locals.label}
      >
        {locals.children}
      </StructTemplate>
    );
  },
}): any);
